import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import EditButton from '../../common/EditButton';
import Spinner from '../../common/spinners/Spinner';
import ContactTimeslotsEdit from './ContactTimeslotsEdit';
import { Button, Dialog } from '@unite-us/ui';
var FORM_NAME = 'timeslots';
var TimeslotsEdit = function TimeslotsEdit(_ref) {
  var initialValues = _ref.initialValues,
    updateContactPreference = _ref.updateContactPreference;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var timeslotsModalRef = useRef(null);
  var openDialog = function openDialog() {
    timeslotsModalRef.current.openDialog();
  };
  var closeDialog = function closeDialog() {
    timeslotsModalRef.current.closeDialog();
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(formValues, form) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            _context.next = 3;
            return updateContactPreference(formValues);
          case 3:
            setIsSubmitting(false);
            closeDialog();
            form.reset();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "timeslots-edit"
  }, /*#__PURE__*/React.createElement(EditButton, {
    edit: openDialog,
    labelText: "Edit",
    id: "timeslots-edit-btn",
    "aria-label": "edit times to contact"
  }), /*#__PURE__*/React.createElement(Form, {
    initialValues: initialValues,
    mutators: _objectSpread({}, arrayMutators),
    onSubmit: onSubmit,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        submitting = _ref3.submitting,
        _ref3$form = _ref3.form,
        change = _ref3$form.change,
        push = _ref3$form.mutators.push,
        values = _valuesInstanceProperty(_ref3);
      return /*#__PURE__*/React.createElement(Dialog, {
        id: "edit-contact-timeslots",
        onCloseModal: closeDialog,
        onRequestClose: closeDialog,
        ref: timeslotsModalRef,
        title: "Edit Timeslots",
        type: "form",
        customSize: {
          width: 670,
          height: 720
        },
        actions: [/*#__PURE__*/React.createElement(Button, {
          id: "edit-timeslots-btn",
          onClick: closeDialog,
          disabled: submitting,
          label: "Cancel"
        }), /*#__PURE__*/React.createElement(Button, {
          id: "edit-timeslots-save-btn",
          onClick: handleSubmit,
          disabled: submitting,
          label: "Save",
          primary: true
        })]
      }, isSubmitting ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(ContactTimeslotsEdit, {
        change: change,
        name: FORM_NAME,
        push: push,
        values: values
      }));
    }
  }));
};
TimeslotsEdit.propTypes = {
  initialValues: PropTypes.object.isRequired,
  updateContactPreference: PropTypes.func.isRequired
};
export default TimeslotsEdit;
//# sourceMappingURL=TimeslotsEdit.js.map